module.exports = __webpack_public_path__ + "static/media/rawpixel-coms.6d3a3f12.jpg";